document.addEventListener('DOMContentLoaded', function () {
  var section = document.querySelector('.diip-pm');
  if (!section) return;

  /* ---------- Gallery ---------- */
  var mainImages = Array.prototype.slice.call(section.querySelectorAll('.diip-pm__main-image'));
  var dots = Array.prototype.slice.call(section.querySelectorAll('.diip-pm__dot'));
  var thumbnails = Array.prototype.slice.call(section.querySelectorAll('.diip-pm__thumbnail'));
  var currentIndex = 0;

  function showImage(index) {
    if (mainImages.length === 0) return;
    currentIndex = (index + mainImages.length) % mainImages.length;

    mainImages.forEach(function (img, i) {
      img.classList.toggle('is-active', i === currentIndex);
    });
    dots.forEach(function (dot, i) {
      dot.classList.toggle('is-active', i === currentIndex);
    });
    thumbnails.forEach(function (thumb, i) {
      thumb.classList.toggle('is-active', i === currentIndex);
    });
  }

  var prevBtn = section.querySelector('[data-gallery-prev]');
  var nextBtn = section.querySelector('[data-gallery-next]');
  if (prevBtn) prevBtn.addEventListener('click', function () { showImage(currentIndex - 1); });
  if (nextBtn) nextBtn.addEventListener('click', function () { showImage(currentIndex + 1); });

  thumbnails.forEach(function (thumb, i) {
    thumb.addEventListener('click', function () { showImage(i); });
  });
  dots.forEach(function (dot, i) {
    dot.addEventListener('click', function () { showImage(i); });
  });

  /* ---------- Quantity selector ---------- */
  var qtyInput = section.querySelector('[data-qty-input]');
  var qtyMinus = section.querySelector('[data-qty-minus]');
  var qtyPlus = section.querySelector('[data-qty-plus]');

  if (qtyMinus && qtyInput) {
    qtyMinus.addEventListener('click', function () {
      var value = parseInt(qtyInput.value, 10) || 1;
      qtyInput.value = Math.max(1, value - 1);
    });
  }
  if (qtyPlus && qtyInput) {
    qtyPlus.addEventListener('click', function () {
      var value = parseInt(qtyInput.value, 10) || 1;
      qtyInput.value = value + 1;
    });
  }

  /* ---------------------------------------------------------------------
     DIIP UPDATE: Variant Pills — คลิกแล้วเปลี่ยนราคาที่แสดง + เปลี่ยน
     variant ที่จะถูกเพิ่มลงตะกร้าจริงตอนกด Add to Cart
  --------------------------------------------------------------------- */
  var variantPills = Array.prototype.slice.call(section.querySelectorAll('[data-variant-pill]'));
  var priceMainEl = document.getElementById('diip-pm-price-main');
  var priceOriginalEl = document.getElementById('diip-pm-price-original');
  var addToCartBtn = section.querySelector('[data-add-to-cart]');

  // เก็บสถานะ "ปกติ" ของปุ่มไว้ตั้งแต่แรก ก่อนจะมีการสลับเป็น sold-out
  var addToCartOriginalHTML = addToCartBtn ? addToCartBtn.innerHTML : '';
  var addToCartOriginalBg = addToCartBtn ? addToCartBtn.getAttribute('data-normal-bg') : '';
  var addToCartOriginalTextColor = addToCartBtn ? addToCartBtn.getAttribute('data-normal-text-color') : '';

  function setAddToCartSoldOut(isSoldOut) {
    if (!addToCartBtn) return;

    if (isSoldOut) {
      addToCartBtn.disabled = true;
      addToCartBtn.classList.add('is-soldout');
      addToCartBtn.textContent = addToCartBtn.getAttribute('data-out-of-stock-text') || 'สินค้าหมด';
      addToCartBtn.style.backgroundColor = addToCartBtn.getAttribute('data-out-of-stock-bg') || '';
      addToCartBtn.style.color = addToCartBtn.getAttribute('data-out-of-stock-text-color') || '';
    } else {
      addToCartBtn.disabled = false;
      addToCartBtn.classList.remove('is-soldout');
      addToCartBtn.innerHTML = addToCartOriginalHTML;
      addToCartBtn.style.backgroundColor = addToCartOriginalBg || '';
      addToCartBtn.style.color = addToCartOriginalTextColor || '';
    }
  }

  function selectVariantPill(pill) {
    variantPills.forEach(function (p) { p.classList.remove('is-active'); });
    pill.classList.add('is-active');

    var price = pill.getAttribute('data-price');
    var promoPrice = pill.getAttribute('data-promo-price');

    if (priceMainEl) {
      priceMainEl.textContent = promoPrice ? promoPrice : price;
    }
    if (priceOriginalEl) {
      if (promoPrice) {
        priceOriginalEl.textContent = price;
        priceOriginalEl.style.display = '';
      } else {
        priceOriginalEl.style.display = 'none';
      }
    }

    // สลับ variant ที่ปุ่ม Add to Cart จะใช้จริง ให้ตรงกับตัวเลือกที่กำลังเลือกอยู่
    if (addToCartBtn) {
      var variantId = pill.getAttribute('data-variant-id');
      addToCartBtn.setAttribute('data-variant-id', variantId || '');
    }

    // DIIP UPDATE: เช็ค Stock ของตัวเลือกที่กำลังเลือกอยู่ สลับปุ่มเป็น "สินค้าหมด" ถ้าจำเป็น
    var isAvailable = pill.getAttribute('data-available') !== 'false';
    setAddToCartSoldOut(!isAvailable);
  }

  if (variantPills.length > 0) {
    variantPills.forEach(function (pill) {
      pill.addEventListener('click', function () { selectVariantPill(pill); });
    });

    // ถ้าไม่มีตัวเลือกไหนถูกตั้งเป็นค่าเริ่มต้นไว้เลย (is_default) ให้ใช้ตัวแรกเป็นค่าเริ่มต้น
    var hasActive = variantPills.some(function (p) { return p.classList.contains('is-active'); });
    selectVariantPill(hasActive ? variantPills.filter(function (p) { return p.classList.contains('is-active'); })[0] : variantPills[0]);
  }

  /* ---------- Add to Cart จริง ---------- */
  var messageEl = document.getElementById('diip-pm-cart-message');

  if (addToCartBtn) {
    addToCartBtn.addEventListener('click', function () {
      var variantId = addToCartBtn.getAttribute('data-variant-id');
      var quantity = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;

      if (!variantId) {
        if (messageEl) {
          messageEl.textContent = 'กรุณาเลือกตัวเลือกสินค้าที่มี SKU ถูกต้องก่อน';
          messageEl.className = 'diip-pm__cart-message is-error';
        }
        return;
      }

      addToCartBtn.disabled = true;
      addToCartBtn.textContent = 'กำลังเพิ่ม...';
      if (messageEl) {
        messageEl.textContent = '';
        messageEl.className = 'diip-pm__cart-message';
      }

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          items: [{ id: variantId, quantity: quantity }],
          sections: 'cart-drawer,cart-icon-bubble',
          sections_url: window.location.pathname,
        }),
      })
        .then(function (response) {
          if (!response.ok) throw new Error('Add to cart failed');
          return response.json();
        })
        .then(function (data) {
          if (messageEl) {
            messageEl.textContent = 'เพิ่มลงตะกร้าแล้ว ✓';
            messageEl.className = 'diip-pm__cart-message is-success';
          }

          var cartDrawer = document.querySelector('cart-drawer');
          if (cartDrawer && typeof cartDrawer.renderContents === 'function') {
            cartDrawer.renderContents(data);
          } else if (data.sections) {
            Object.keys(data.sections).forEach(function (sectionId) {
              var target = document.getElementById(sectionId);
              if (!target) return;
              var temp = document.createElement('div');
              temp.innerHTML = data.sections[sectionId];
              var replacement = temp.firstElementChild;
              if (replacement) target.replaceWith(replacement);
            });
            var cartIcon = document.getElementById('cart-icon-bubble');
            if (cartIcon) cartIcon.click();
          }
        })
        .catch(function () {
          if (messageEl) {
            messageEl.textContent = 'เพิ่มไม่สำเร็จ กรุณาลองใหม่';
            messageEl.className = 'diip-pm__cart-message is-error';
          }
        })
        .finally(function () {
          addToCartBtn.disabled = false;
          addToCartBtn.innerHTML = addToCartOriginalHTML;
        });
    });
  }
});
